<div class="top">
  <h2>Elementos de Barreras</h2>
  <p *ngIf="casingCount!=0">Pozo de  {{casingCount}} Casing.</p>
</div>
<!-- <div class="reported">
  <div class="report" *ngFor="let item of reportedBarrierElements; let i = index">
    <form #form="ngForm" class = "well-integrity-report">
      <mat-form-field class="selector" appearance="fill">
        <mat-label>Problema reportado en</mat-label>
        <mat-select [disabled]="true" name="element" [(ngModel)]="item.element">
          <mat-option [value]="item.element">
            {{item.element.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="comment">
        <input matInput name="comment" [disabled]="readOnlyContent" maxlength="255" type="text" [(ngModel)]="item.comment"
          [title]="item.comment" (ngModelChange)="onSectionTouched('wellIntegrity'); commentUpdated(i, item.comment)" />
      </mat-form-field>
      <button mat-button [ngClass]="{ready: true}" [disabled]="!form.dirty" (click)="updateBarrierProblem(item, form.form);">LISTO</button>
      <button mat-icon-button [ngClass]="{remove: true}" [disabled]="readOnlyContent" (click)="removeBarrierProblem(item)">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
    </form>
  </div>
</div>
<div class="report well-integrity-report" *ngIf="!readOnlyContent">
  <mat-form-field class="selector" appearance="fill">
    <mat-label>Reportar problema en</mat-label>
    <mat-select [(ngModel)]="chosenBarrierElement" (selectionChange)="enableComment(); onSectionTouched('wellIntegrity')">
      <mat-option>Seleccione elemento</mat-option>
      <mat-option *ngFor="let barrierElement of barrierElements" [value]="barrierElement">
        {{barrierElement.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field *ngIf="problemDescriptionIsEnabled">
    <mat-label>Describí el problema</mat-label>
    <input matInput required type="text" [(ngModel)]="problemDescription" maxlength="255"
      (ngModelChange)="enableCommentSubmission(); onSectionTouched('wellIntegrity')" />
  </mat-form-field>
  <button mat-button [ngClass]="{ready: true}" [disabled]="!problemSubmissionIsEnabled" (click)="submitBarrierProblem()">LISTO</button>
</div> -->

<div class="main-ho-barrier">
  <table mat-table [dataSource]="barrierElementsRelation" class="barrierElementsTable">
    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Elementos </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"> {{element.name}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="problemDate">
        <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Fecha </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index">
          <mat-form-field>
            <input matInput [matDatepicker]="problemDate"
                [readonly]="readOnlyContent || canChangeBarrierElements()"
                [(ngModel)]="element.problemDate"
                (dateChange)="enableSaveButton(i); onSectionTouched('wellIntegrity')"
                name="problemDate">
            <mat-datepicker-toggle matSuffix [disabled]="readOnlyContent || canChangeBarrierElements()" [for]="problemDate"></mat-datepicker-toggle>
            <mat-datepicker #problemDate></mat-datepicker>
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="testPressure">
        <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Presión de Prueba [psi] </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index">
          <mat-form-field>
            <mat-label>Indique valor</mat-label>
            <input matInput digitOnly inputmode="numeric" [min]="1" [(ngModel)]="element.testPressure" [readonly]="readOnlyContent || canChangeBarrierElements()"
              (change)="enableSaveButton(i); onSectionTouched('wellIntegrity')"
              (keyup)="enableSaveButton(i); onSectionTouched('wellIntegrity')" />
          </mat-form-field>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="testApproved">
        <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> ¿Prueba Satisfactoria? </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index">
                <mat-button-toggle-group  aria-label="Font Style" [value]="element.testApproved"  [(ngModel)]="element.testApproved" (ngModelChange)="enableSaveButton(i)" [disabled]="readOnlyContent || canChangeBarrierElements()" >
                    <mat-button-toggle  value="NO"  [ngClass]="element.testApproved == 'NO' ? 'red-button-toggle' : ''">NO</mat-button-toggle>
                    <mat-button-toggle  value="SI" [ngClass]="element.testApproved == 'SI' ? 'green-button-toggle' : ''" >SI</mat-button-toggle>
                </mat-button-toggle-group> 
                <mat-hint class="alert" *ngIf="!element.testApproved && !readOnlyContent">
                  Dato obligatorio.
                </mat-hint> 
        </mat-cell> 
    </ng-container>
    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index" [ngClass]="'mat-column-save'">
            <button mat-mini-fab (click)="openComments(barrierElementsRelation[i], i, $event, readOnlyContent );" class="comment-ho-icon" name="openComments">
            <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
            <div class="circle-comments" *ngIf="barrierElementsRelation[i].comment"></div>
            <span class = "comment">Comentar</span>
          </button>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="5">
            <div class="footer">
                <div class="footer-no-data">No se encontraron datos.</div>
                <div class="footer-no-data-origin">No hay datos para mostrar, validar que existan datos de "Casing" en el sistema de origen y el campo de "Tipo de pozo" y "Tipo de producción" deben estar completo.</div>
            </div>
        </mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>

</table>
</div>
<br>
<div class="barrierElements-actions" *ngIf="!readOnlyContent">
  <button mat-button class="save" title="Guardar" (click)="save()">
    <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
  </button>
</div>